<mat-dialog-content>
  <lemon-dialog-header>
    @if (lisaa) {
      Lisää kirjanpitotili
    }
    @if (!lisaa) {
      Muokkaa kirjanpitotiliä
    }
  </lemon-dialog-header>

  <form novalidate>
    <div style="max-width: 350px; margin-bottom: 10px">
      <!-- <pre>{{ numero?.errors | json }}</pre> -->

      <mat-form-field>
        <mat-label>Vanhempi</mat-label>
        <mat-select [formField]="lomake.vanhempi">
          @for (tili of tilitObservable | async; track tili) {
            <mat-option [value]="tili.numero">{{ tili.numero }} {{ tili.nimi }}</mat-option>
          }
        </mat-select>
        @if (naytaVirhe(lomake.vanhempi, 'required')) {
          <mat-error> Vanhempi puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Numero</mat-label>
        <input type="text" #numeroInput [formField]="lomake.numero" maxlength="5" minlength="5" decimalNumberField [numberOfDecimals]="0" matInput class="skip-space-quick-toggle" />
        @if (naytaVirhe(lomake.numero, 'vanhempipuuttuu')) {
          <mat-error> Tilille ei löydy paikkaa hierarkiassa. </mat-error>
        }
        @if (onkoVirhe(lomake.numero, 'max') || naytaVirhe(lomake.numero, 'min')) {
          <mat-error> Asiakaskohtaisen tilinumeron on oltava 5 merkkiä pitkä. </mat-error>
        }
        @if (naytaVirhe(lomake.numero, 'required')) {
          <mat-error> Numero puuttuu </mat-error>
        }
        @if (naytaVirhe(lomake.numero, 'duplicate')) {
          <mat-error> Tilinumero on jo käytössä. </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nimi suomeksi</mat-label>
        <input type="text" #nimiFiInput [formField]="lomake.nimiFi" matInput class="skip-space-quick-toggle" />
        @if (naytaVirhe(lomake.nimiFi, 'required')) {
          <mat-error> Nimi puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nimi englanniksi</mat-label>
        <input type="text" #nimiEnInput [formField]="lomake.nimiEn" matInput class="skip-space-quick-toggle" />
        @if (naytaVirhe(lomake.nimiEn, 'required')) {
          <mat-error> Nimi puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>ALV-tyyppi</mat-label>
        <mat-select [formField]="lomake.alvtyyppi">
          @for (lokalisoituAlvtyyppi of lokalisoidutAlvtyypit; track lokalisoituAlvtyyppi) {
            <mat-option [value]="lokalisoituAlvtyyppi.tyyppi">{{ lokalisoituAlvtyyppi.nimi }}</mat-option>
          }
        </mat-select>
        @if (naytaVirhe(lomake.alvtyyppi, 'required')) {
          <mat-error> Valinta puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Oletus ALV-käsittely</mat-label>
        <mat-select [formField]="lomake.alv" [compareWith]="vertaaAlvMaarityksia">
          @for (alv of alvt; track alv) {
            <mat-option [value]="alv">{{ alv.nimi }}</mat-option>
          }
        </mat-select>
        @if (naytaVirhe(lomake.alv, 'required')) {
          <mat-error> Oletus puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-checkbox [formField]="lomake.aktiivinen">Aktiivinen</mat-checkbox>
      <div style="margin-top: 5px">
        <mat-checkbox [formField]="lomake.reskontraActive">Reskontra päällä</mat-checkbox>
      </div>

      <div style="margin-top: 25px; display: flex; flex-direction: column">
        <mat-checkbox [formField]="lomake.automaattinenPoisto">Automaattiset poistot päällä</mat-checkbox>
        <div style="display: flex; margin-top: 15px">
          <mat-form-field style="margin-right: 30px; width: 60px">
            <mat-label>Poistoprosentti</mat-label>
            <input type="number" #poistoProsentti [formField]="lomake.automaattinenPoistoProsentti" matInput class="skip-space-quick-toggle" />
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field style="width: 260px">
            <mat-label>Poistotili</mat-label>
            <input type="text" tahtiOhjeeseen [formField]="lomake.automaattinenPoistoTili" matInput [matAutocomplete]="automaattinenPoistoAutocomplete" autocomplete="automaattinenPoisto" placeholder="Poistotili" data-lpignore="true" />
            <mat-autocomplete #automaattinenPoistoAutocomplete="matAutocomplete" [panelWidth]="350" [displayWith]="displayPoistotili">
              @for (tili of suodatetutTilitSubject | async; track tili) {
                <mat-option [value]="tili.kirjanpitotili"> {{ tili.kirjanpitotili.numero }} {{ tili.kirjanpitotili.nimi }} </mat-option>
              }
            </mat-autocomplete>
            @if (naytaVirhe(lomake.automaattinenPoistoTili, 'required')) {
              <mat-error> Valinta puuttuu </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Kirjanpitotilin muokkaus: Peruuta ja sulje dialog">{{ 'yleiset.peruuta' | translate | async }}</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Kirjanpitotilin muokkaus, tallenna tiedot" [actionContext]="[$any(lomake().value())]">Tallenna</app-primary-button>
</mat-dialog-actions>
